<template>
  <div>
    <div class="header">
      <slot name="header">
        <mu-appbar :title="title" style="text-align: center;">
          <img slot="left" src="@/assets/img/icon/icon-arrow-left.svg" alt="" width="20" height="20" @click="$router.back(-1)">
        </mu-appbar>
      </slot>
    </div>
    <div class="page-wrap" ref="page">
      <mu-refresh-control v-if="!disableRefresh" :refreshing="refreshing" :trigger="trigger" @refresh="refresh"/>
      <slot></slot>
      <mu-infinite-scroll v-if="!disableLoad" :scroller="trigger" :loading="loading" @load="loadMore"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },

    // 是否禁止下拉刷新
    disableRefresh: {
      type: Boolean,
      default: false
    },

    // 是否禁止上拉加载
    disableLoad: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      trigger: null,
      loading: false,
      refreshing: false
    }
  },

  mounted () {
    this.trigger = this.$refs.page
  },

  methods: {
  	refresh () {
  		this.$emit('refresh')
  	},

    startRefresh () {
      this.refreshing = true
    },

    stopRefresh () {
      this.refreshing = false
    },

    loadMore () {
      this.$emit('load')
    },

    startLoad () {
      this.loading = true
    },

    stopLoad () {
      this.loading = false
    }
  }
}
</script>

<style scoped>
.page-wrap{
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding-top: 56px
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99
}
</style>


// WEBPACK FOOTER //
// src/components/Page.vue